import React from 'react';
import { technology } from './technology';
import TechHex from './TechHex';
import "./TechStack.css"

const TechStack = () => {
    return (
    <section className="techStackList">
        <div className="TechContainer">
            {technology.map((hex) =>{
                return <TechHex key={technology.indexOf(hex)} {...hex}></TechHex>
            })}
        </div>
    </section>
    )
}

export default TechStack
